import styled from 'styled-components';

const avatarSize = {
  xs: '40px',
  sm: '60px',
  md: '80px',
  lg: '100px',
  xl: '120px'
};

const StyledAvatar = styled.div`
  width: ${(props) => avatarSize[props.size]};
  height: ${(props) => avatarSize[props.size]};
  border-radius: 50%;
  background-size: cover;
  background-image: url(${(props) => props.src});
  box-shadow: ${(props) => props.shadow && props.theme.shadows.depth1};
`;

export const Avatar = StyledAvatar;